<template>
<div class="chapter">
<div class="inner_page">
<p class="ct"><a href="#/contents#en1" id="fn1"><i>Book One</i></a></p>
<p class="ct1"><a href="#/contents#en1">THE<br/> MIDNIGHT READER</a></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// book1.vue?5d30b02e